<template>
  <v-dialog v-model="dialog" persistent max-width="90%">
    <v-card>
      <v-alert-dialog ref="alert"> </v-alert-dialog>

      <!-- Diálogo de confirmación -->
      <v-dialog
        v-model="dialog_confirmar"
        max-width="450"
        persistent
      >
        <v-card>
          <v-card-title class="text-h6">
            Confirmar Decisión
          </v-card-title>

          <v-card-text class="py-4">
            <div class="text-center">
              <v-icon 
                :color="decision_proveedor === 3 ? 'green' : decision_proveedor === 2 ? 'orange darken-2' : 'red'" 
                size="64" 
                class="mb-3"
              >
                {{ decision_proveedor === 3 ? 'mdi-check-circle' : decision_proveedor === 2 ? 'mdi-file-document-edit' : 'mdi-close-circle' }}
              </v-icon>
              
              <p class="text-h6 mb-2">
                {{ decision_proveedor === 3 ? 'Aceptar Proveedor' : decision_proveedor === 2 ? 'Revisión de Documentación' : 'Rechazar Proveedor' }}
              </p>
              
              <p class="text-body-1 grey--text text--darken-1">
                ¿Está seguro que desea continuar?
              </p>
            </div>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="pa-4">
            <v-btn
              text
              color="green"
              @click="dialog_confirmar = false"
            >
              <v-icon left>mdi-close</v-icon>
              No, Cancelar
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="red"
              text
              @click="save"
            >
              <v-icon left>mdi-check</v-icon>
              Sí, Continuar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-card-title> Validar información del Proveedor </v-card-title>

      <v-card-text v-if="loading" class="pa-6">
        <div
          class="d-flex flex-column align-center justify-center"
          style="min-height: 220px"
        >
          <v-progress-circular
            indeterminate
            size="96"
            width="8"
            color="primary"
          />
          <div class="mt-5 grey--text text--darken-2 text-h6">
            {{ saving ? "Guardando Información..." : "Cargando información..."}}
          </div>
        </div>
      </v-card-text>

      <v-card-text v-else>
        <template v-for="grupo in grupos">
          <div
            class="documents-section"
            :key="`g-${grupo.id_proveedor_requisito_grupo}`"
          >
            <h3
              class="text-h6 font-weight-bold grey--text text--darken-2 my-4"
              style="justify-self: center"
            >
              {{ grupo.nombre }}
            </h3>

            <v-row>
              <template v-for="requisito in grupo.requisitos">
                <v-col
                  :key="`r-${requisito.id_proveedor_requisito}`"
                  :cols="requisito.tipo != 6 ? requisito.num_columnas : 6"
                  class="my-0 py-0"
                >
                  <template v-if="requisito.documento == null">
                    <div :key="requisito.id_proveedor_requisito">
                      <div class="text-subtitle-2">{{ requisito.nombre }}:</div>
                      <div>Documento o Dato no Proporcionado</div>
                    </div>
                  </template>
                  <template v-else-if="requisito.tipo == 4">
                    <VFileInputError
                      :file-name="requisito.documento"
                      :label="requisito.nombre"
                      download-url="/api/Proveedores/DescargarProveedorDocumento"
                      :token="token"
                      :status="requisito.validado"
                      :previous-note="requisito.error_anterior"
                      :note="requisito.error"
                      @change="onDocumentoChange(requisito, $event)"
                    />
                  </template>

                  <template v-else>
                    <div class="text-subtitle-2">{{ requisito.nombre }}:</div>
                    <v-row class="pa-0 ma-0">
                      <v-col cols="auto" class="pa-0 ma-0">
                        <v-check
                          v-model="requisito.validado"
                          class="pa-0 ma-0"
                          dense
                          hide-details
                          indeterminate
                        />
                      </v-col>

                      <v-col class="pa-0 ma-0 pl-2" style="align-self: center">
                        <template v-if="requisito.tipo == 2 || requisito.tipo == 7">
                          <div>{{ requisito.documento }}</div>
                        </template>
                        <template v-if="requisito.tipo == 3 || requisito.tipo == 8">
                          <v-autocomplete-text
                            v-model="requisito.documento"
                            :url-get="requisito.select_url"
                            :item-value="requisito.select_value"
                          >
                          </v-autocomplete-text>
                        </template>

                        <template v-if="requisito.tipo == 5">
                          <v-btn
                            @click="nuevaPestana(requisito.documento)"
                            block
                            color="primary"
                            text
                          >
                            Abrir Link de Google Maps
                          </v-btn>
                        </template>
                        <template v-if="requisito.tipo == 6">
                          <v-endpoint-text
                            :url-get="`/Catalogos/MunicipioNombreCompleto/${requisito.documento}`"
                          >
                          </v-endpoint-text>
                        </template>
                      </v-col>
                      <v-col
                        v-if="requisito.validado == false"
                        cols="12"
                        class="ma-0 pa-0 pt-3"
                      >
                        <v-textarea
                          v-model="requisito.error"
                          outlined
                          dense
                          hide-details
                          rows="1"
                          auto-grow
                          :label="`Motivo de Rechazo - ${requisito.nombre}`"
                        >
                        </v-textarea>
                      </v-col>
                    </v-row>
                    <div
                      v-if="requisito.error_anterior != null"
                      class="text-caption note-style red--text"
                    >
                      Motivo de Rechazo Anterior: {{ requisito.error_anterior }}
                    </div>
                  </template>

                  <template v-if="requisito.nota != null">
                    <div class="text-caption note-style">
                      Nota: {{ requisito.nota }}
                    </div>
                  </template>
                </v-col>
              </template>
            </v-row>
          </div>
        </template>

        <v-row>
          <v-col cols="12">
            <v-card flat class="pa-4">
              <v-card-subtitle class="text-center pb-2">
                <h3 class="text-h6 font-weight-medium">Decisión sobre Proveedor</h3>
                <p class="text-caption grey--text mt-1">Seleccione una opción para continuar</p>
              </v-card-subtitle>
              
              <v-item-group v-model="decision_proveedor">
                <v-row class="mt-2">
                  <!-- Aceptar -->
                  <v-col cols="12" md="4">
                    <v-item v-slot="{ active, toggle }" :value="3">
                      <v-card
                        :class="active ? 'elevation-8' : 'elevation-2'"
                        :color="active ? 'green' : 'white'"
                        @click="toggle"
                        class="transition-swing cursor-pointer"
                        height="160"
                      >
                        <v-card-text class="d-flex flex-column align-center justify-center fill-height">
                          <v-avatar
                            :color="active ? 'white' : 'green lighten-4'"
                            size="64"
                            class="mb-3"
                          >
                            <v-icon
                              :color="active ? 'green' : 'green darken-2'"
                              size="36"
                            >
                              mdi-check-circle
                            </v-icon>
                          </v-avatar>
                          <h4 :class="active ? 'white--text' : 'green--text text--darken-2'" class="text-h6 font-weight-bold">
                            Aceptar
                          </h4>
                          <p :class="active ? 'white--text' : 'grey--text'" class="text-caption text-center mt-1 mb-0">
                            Aprobar proveedor
                          </p>
                        </v-card-text>
                      </v-card>
                    </v-item>
                  </v-col>

                  <!-- Revisión -->
                  <v-col cols="12" md="4">
                    <v-item v-slot="{ active, toggle }" :value="2">
                      <v-card
                        :class="active ? 'elevation-8' : 'elevation-2'"
                        :color="active ? 'orange darken-2' : 'white'"
                        @click="toggle"
                        class="transition-swing cursor-pointer"
                        height="160"
                      >
                        <v-card-text class="d-flex flex-column align-center justify-center fill-height">
                          <v-avatar
                            :color="active ? 'white' : 'orange lighten-4'"
                            size="64"
                            class="mb-3"
                          >
                            <v-icon
                              :color="active ? 'orange darken-2' : 'orange darken-3'"
                              size="36"
                            >
                              mdi-file-document-edit
                            </v-icon>
                          </v-avatar>
                          <h4 :class="active ? 'white--text' : 'orange--text text--darken-3'" class="text-h6 font-weight-bold">
                            Revisión
                          </h4>
                          <p :class="active ? 'white--text' : 'grey--text'" class="text-caption text-center mt-1 mb-0">
                            Solicitar correcciones
                          </p>
                        </v-card-text>
                      </v-card>
                    </v-item>
                  </v-col>

                  <!-- Rechazar -->
                  <v-col cols="12" md="4">
                    <v-item v-slot="{ active, toggle }" :value="4">
                      <v-card
                        :class="active ? 'elevation-8' : 'elevation-2'"
                        :color="active ? 'red' : 'white'"
                        @click="toggle"
                        class="transition-swing cursor-pointer"
                        height="160"
                      >
                        <v-card-text class="d-flex flex-column align-center justify-center fill-height">
                          <v-avatar
                            :color="active ? 'white' : 'red lighten-4'"
                            size="64"
                            class="mb-3"
                          >
                            <v-icon
                              :color="active ? 'red' : 'red darken-2'"
                              size="36"
                            >
                              mdi-close-circle
                            </v-icon>
                          </v-avatar>
                          <h4 :class="active ? 'white--text' : 'red--text text--darken-2'" class="text-h6 font-weight-bold">
                            Rechazar
                          </h4>
                          <p :class="active ? 'white--text' : 'grey--text'" class="text-caption text-center mt-1 mb-0">
                            Denegar proveedor
                          </p>
                        </v-card-text>
                      </v-card>
                    </v-item>
                  </v-col>
                </v-row>
              </v-item-group>
            </v-card>
          </v-col>
          <v-col v-if="decision_proveedor == 4" cols="12">
            <v-textarea
              v-model="motivo_rechazo"
              outlined
              dense
              hide-details
              auto-grow
              label="Motivo del Rechazo"
            >
            </v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions v-if="!loading || saving">
        <v-btn
          color="green"
          text
          @click="close"
        >
          Cerrar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          :disabled="decision_proveedor == null || saving"
          color="red"
          text
          @click="openDialogConfim"
          :loading="saving"
        >
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import VAlertDialog from "@/components/VAlertDialog.vue";
import VFileInputError from "@/components/VFileInputError.vue";
import VAutocompleteText from "@/components/VAutocompleteText.vue";
import VEndpointText from '@/components/VEndpointText.vue';

export default {
  components: {
    VAlertDialog,
    VFileInputError,
    VAutocompleteText,
    VEndpointText
  },
  computed: {
    ...mapState(["token"]),
  },
  data: () => ({
    grupos: [],
    loading: false,
    dialog: false,
    decision_proveedor: null,
    motivo_rechazo: null,
    saving: false,
    dialog_confirmar: false,
    id_proveedor_usuario: null,
  }),
  mounted() {},
  methods: {
    open(id_proveedor_usuario) {
      this.grupos = [];
      this.dialog = true;
      this.loading = true;

      this.id_proveedor_usuario = id_proveedor_usuario;

      axios
        .get(`/Proveedores/DetallesProveedorUsuario/${this.id_proveedor_usuario}`)
        .then((response) => {
          this.grupos = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    close() {
      if (this.loading) return;

      this.grupos = [];
      this.loading = false;
      this.dialog = false;
      this.decision_proveedor = null;
      this.motivo_rechazo = null;
      this.saving = false;
      this.dialog_confirmar = false;
      this.id_proveedor_usuario = null;
    },
    onDocumentoChange(requisito, payload) {
      requisito.validado = payload.status;
      requisito.error = payload.note;
    },
    nuevaPestana(url) {
      window.open(url, "_blank");
    },
    isValid(){
      var requisitos = this.grupos
        .map(g => g.requisitos)
        .flat()
        .filter(requisito => requisito.documento != null);
      
      for (let i = 0; i < requisitos.length; i++) {
        const requisito = requisitos[i];
        
        if(requisito.validado == null){
          this.$refs.alert.setMessage(
            '',
            `Debe de indicar si el campo ${requisito.nombre} es correcto o incorrecto`
          );
          this.$refs.alert.open();
          return false;
        }

        if(requisito.validado == false && (requisito.error == null || requisito.error.length <= 0)){
          this.$refs.alert.setMessage(
            '',
            `Debe de indicar el Motivo de Rechazo del campo ${requisito.nombre}`
          );
          this.$refs.alert.open();
          return false;
        }
      }

      if(this.decision_proveedor == 3 && requisitos.filter(req => req.validado == false).length > 0){
        const nombre_documentos = requisitos
        .filter(req => req.validado === false)
        .map(req => `• ${req.nombre}`)
        .join('\n');

        this.$refs.alert.setMessage(
          '',
          `No es posible aprobar al proveedor mientras existan documentos o datos rechazados. \n\n Documentos o datos rechazados: \n${nombre_documentos}`
        );

        this.$refs.alert.open();
        return false;
      }

      if(this.decision_proveedor == 2 && requisitos.filter(req => req.validado == false).length == 0){
        this.$refs.alert.setMessage(
          '',
          `No es posible solicitar revisión de documentación. \n\n Debe marcar al menos un documento o dato como rechazado antes de continuar.`
        );

        this.$refs.alert.open();
        return false;
      }

      return true;
    },
    openDialogConfim(){
      if(!this.isValid()) return;

      this.dialog_confirmar = true;
    },
    save(){
      this.dialog_confirmar = false;
      this.saving = true;
      this.loading = true;

      var requisitos = this.grupos
        .map(g => g.requisitos)
        .flat()
        .filter(requisito => requisito.documento != null)
        .map(req => ({
          id_proveedor_requisito: req.id_proveedor_requisito,
          validado: req.validado,
          comentario: req.error
        }));

      var payload = {
        id_proveedor_usuario: this.id_proveedor_usuario,
        estado: this.decision_proveedor,
        motivo_rechazo: this.motivo_rechazo,
        requisitos: requisitos
      };

      axios
      .post('/Proveedores/ValidarProveedorUsuario', payload)
      .then(() => {
        this.$emit('change', null);
        this.saving = false;
        this.loading = false;
        this.close();
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        this.saving = false;
        this.loading = false;
      })
    }
  },
};
</script>
